const SUBJECT_INDEX_SYNC_ERROR_CODES = [
  "exam_index_mismatch",
  "exam_index_behind_unanswered",
  "exam_index_ahead",
  "EXAM_INDEX_MISMATCH",
];

function getSubmitErrorCode(error) {
  if (!error || typeof error !== "object") {
    return "";
  }
  return error.errorCode || error.code || "";
}

function isSubjectIndexSyncError(text, error) {
  const message = String(text || "");
  const code = getSubmitErrorCode(error);
  return (
    SUBJECT_INDEX_SYNC_ERROR_CODES.includes(code) ||
    message.includes("提交题目序号错误") ||
    message.includes("题目索引超出范围") ||
    message.includes("状态不同步")
  );
}

function isRecoverableSubjectIndexSyncError(error, text) {
  return isSubjectIndexSyncError(text, error);
}

module.exports = {
  getSubmitErrorCode,
  isRecoverableSubjectIndexSyncError,
  isSubjectIndexSyncError,
};
